import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-column">
            <div className="footer-logo">
              <span className="footer-logo-text">Trademark</span>
              <span className="footer-logo-highlight">Texticon</span>
            </div>
            <p className="footer-description">
              Your trusted partner for comprehensive trademark registration services. 
              Protecting brands and intellectual property across the United States with 
              expert legal guidance and USPTO filing expertise.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
              <li><button onClick={() => scrollToSection('services')}>Our Services</button></li>
              <li><button onClick={() => scrollToSection('process')}>Registration Process</button></li>
              <li><button onClick={() => scrollToSection('pricing')}>Pricing Plans</button></li>
              <li><button onClick={() => scrollToSection('faq')}>FAQ</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h3 className="footer-heading">Our Services</h3>
            <ul className="footer-links">
              <li><a href="#services">Trademark Search</a></li>
              <li><a href="#services">USPTO Filing</a></li>
              <li><a href="#services">Brand Protection</a></li>
              <li><a href="#services">Office Action Response</a></li>
              <li><a href="#services">Trademark Monitoring</a></li>
              <li><a href="#services">Legal Consultation</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h3 className="footer-heading">Contact Us</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>600 W Broadway Suite 700<br />San Diego, CA 92101</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={18} />
                <a href="tel:+11231234567">+1 (123) 123-4567</a>
              </div>
              <div className="footer-contact-item">
                <Mail size={18} />
                <a href="mailto:info@trademarktexticon.com">info@trademarktexticon.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Trademark Texticon. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms-conditions">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
